import moment from 'moment';

const formatDateWithoutTS = (date: string, format = 'DD-MMM-YYYY'): string => {
  return moment(new Date(date)).format(format);
};

export default formatDateWithoutTS;
